// Tools
import { useSyncExternalStore } from "react";

// Ширина, после которой отключается возможность перетаскивать окна (планшеты и мобилки)
export const SPLIT_PANE_INTERACTIVE_MIN_WIDTH_PX = 1200;

const getMediaQuery = () =>
	window.matchMedia(
		`(min-width: ${SPLIT_PANE_INTERACTIVE_MIN_WIDTH_PX}px)`,
	);

const subscribeInteractive = (onChange: () => void) => {
	const mq = getMediaQuery();
	mq.addEventListener("change", onChange);
	return () => mq.removeEventListener("change", onChange);
};

const getInteractiveSnapshot = () => getMediaQuery().matches;

const getServerInteractiveSnapshot = () => true;

export const useSplitPaneLayoutInteractive = () =>
	useSyncExternalStore(
		subscribeInteractive,
		getInteractiveSnapshot,
		getServerInteractiveSnapshot,
	);
